module.exports = __webpack_public_path__ + "img/mediumAfsorder.fc9cd786.svg";